/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
// utils
import {
  COMMENTING_2_0_ACTIVATION_READY,
  DATA_MIGRATION_CONFIRMED,
  DATA_MIGRATION_DONE,
  DATA_MIGRATION_ERROR,
  DATA_MIGRATION_NONE,
  DATA_MIGRATION_PROGRESS,
  DATA_MIGRATION_READY
} from 'utils/consts/migration';
// material
import { ReactComponent as UpgradeIcon } from 'assets/icons/upgrade.svg'
// content
import ActivateMigration from './activatemigration/activatemigration';
import StartMigration from './startmigration/startmigration';
import InProgress from './inprogress/inprogress';
import MigrationComplete from './migrationcomplete/migrationcomplete';
import Failed from './failed/failed';
// styles
import injectSheet from "react-jss";
import styles from './migrationstatuswidget_styles';
import { Icon } from '@insticator/insticator-ui/dist/material';

const showWidgetOnPages = ['/dashboard/commenting/code', '/dashboard/commenting/advanced', '/dashboard/commenting/configuration', '/dashboard/productmanager']

/* ========== ~~~~~~~~~~ MIGRATION STATUS WIDGET ~~~~~~~~~~ ========== */
const MigrationStatusWidget = injectSheet(styles)((props) => {
  const mocked = useSelector(state => state.session.mocked);

  const { migrationStatus, requestFailed, migration: { canStartMigration } } = useSelector(state => state.migrationStatus)
  const { accountProducts, accountHasCommentingV1 } = useSelector(state => state.account) 
  const popoverRef = useRef()
  const { currentPage } = useSelector(state => state.app)

  const isCommentingPage = showWidgetOnPages.includes(currentPage)

  const [isOpen, setIsOpen] = useState(true)

  const dispayedStatus = requestFailed ? DATA_MIGRATION_ERROR : migrationStatus

  if (!isCommentingPage) return null

  if(!accountHasCommentingV1) return null

  if (!mocked || (migrationStatus === DATA_MIGRATION_CONFIRMED || migrationStatus === DATA_MIGRATION_NONE || migrationStatus === null || accountProducts.length === 0)) return null

  return (
    <div className={`migrationstatuswidget ${props.classes.migrationstatuswidget}`}>
      <div className={`popover isopen-${isOpen}`} ref={popoverRef}>
        {dispayedStatus === COMMENTING_2_0_ACTIVATION_READY && <ActivateMigration />}
        {dispayedStatus === DATA_MIGRATION_READY && <StartMigration />}
        {dispayedStatus === DATA_MIGRATION_PROGRESS && <InProgress />}
        {dispayedStatus === DATA_MIGRATION_DONE && <MigrationComplete />}
        {dispayedStatus === DATA_MIGRATION_ERROR && <Failed />}
        <Icon name={'times-circle'} className={'close'} handleClick={() => setIsOpen(false)} />
        <span className='arrow' />
      </div>
      <div className={`toggle status-${dispayedStatus.toLowerCase()} canstartmigration-${!!canStartMigration}`} onClick={() => setIsOpen(true)}>
        <UpgradeIcon />
      </div>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MigrationStatusWidget